{
  "title": "Melf's Minute Meteors",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "3rd-level evocation",
  "level": 3,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (niter, sulfur, and pine tar formed into a bead)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "You create six tiny meteors in your space. They float in the air and orbit you for the spell’s duration. When you cast the spell — and as a bonus action on each of your turns thereafter — you can expend one or two of the meteors, sending them streaking toward a point or points you choose within 120 feet of you. Once a meteor reaches its destination or impacts against a solid surface, the meteor explodes. Each creature within 5 feet of the point where the meteor explodes must make a Dexterity saving throw. A creature takes 2d6 fire damage on a failed save, or half as much damage on a successful one.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, the number of meteors created increases by two for each slot level above 3rd."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "wizard"]
}
